import React, { Fragment } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

export const defaultDialogTitle = 'AP Practice Exam Security';

export const getPracticeExamUpdate = (secureBrowserLink) => ({
  dialogTitle: defaultDialogTitle,
  header: 'Important Practice Exam Update',
  description:
    'The question bank has been updated to better support school closures and students at home. All free-response questions may now be assigned to students for digital testing using mobile phones, tablets, and computers. Please review the updated security policy below.',
  blocks: [
    'I understand that the 2020 AP Exam will ask students to answer free-response questions on digital devices at home; as such, all free-response questions, including all free-response questions on practice exams, can be assigned digitally to students at home.',
    <Fragment>
      To protect the security of multiple-choice questions for teacher use, I
      will not assign multiple-choice practice exam questions as take-home
      assignments. I will use AP Classroom to assign online or in print, using
      the secure {secureBrowserLink} for online tests or collecting print tests
      back from my students in class.
    </Fragment>,
    'I will not post AP questions on any other website or software. I understand this limits the ability for all AP teachers to use questions with their students, as well as violates College Board’s copyright policies, and may result in termination of access to AP resources.',
  ],
});

export const getAttestationUpdateJuly2020 = () => ({
  dialogTitle: 'AP Question Security Update',
  description: 'Please review and confirm the updated security policy below.',
  blocks: [
    <Fragment>
      I will not post any AP questions, answer keys, or scoring guidelines on
      other websites or software, as doing so limits the number of secure AP
      questions available to teachers. I will not allow online assignments or
      test booklets generated in AP Classroom with secure Practice Exam
      questions (denoted with a{' '}
      {
        <Icon
          name="practice_question"
          height="16"
          width="16"
          className="-mb-1"
        />
      }
      ) to be taken outside of the classroom or used without my supervision.
      Additionally, I understand that publicly disclosing any AP questions may
      result in termination of my access to AP resources.
    </Fragment>,
    <Fragment>
      I understand I will have the <span className="italic">option</span> of
      requiring students to use the LockDown Browser for any specific
      assignment.
    </Fragment>,
  ],
});

export const getDefaultQBAttestationUpdate = (secureBrowserLink) => ({
  dialogTitle: defaultDialogTitle,
  description:
    'The question bank now includes full AP practice exams to help you prepare students for May 2020. In order to provide all teachers with secure full exams, please agree to the following security measures to keep all of the enclosed practice questions protected.',
  blocks: [
    <Fragment>
      I understand that AP Practice Exams are for in-classroom use only. To
      ensure their integrity I will only assign them in my class where I can
      ensure their security and will not assign as take-home assignments. I will
      use AP Classroom to assign online or in print, using the secure{' '}
      {secureBrowserLink} for online tests or collecting print tests back from
      my students after administering them in class, and will not post them on
      any other website or software. I understand that additional distribution
      of the AP Practice Exam limits the ability for all AP teachers to use
      these exams with their students, as well as violating College Board’s
      copyright policies and may result in termination of access to AP
      resources.
    </Fragment>,
  ],
});
